import Modal from './Modal';

// ─── AUTH PROMPT MODAL ────────────────────────────────────────────────────────
//
//  Shown when a guest (no account) or an unverified user attempts an action
//  that requires a verified account.  Presents Sign In / Create Account CTAs.
//
//  Props:
//    action    {string}    key identifying the gated action (see ACTION_LABELS)
//    onSignIn  {function}  called when the user chooses to sign in
//    onSignUp  {function}  called when the user chooses to create an account
//    onClose   {function}  called when the modal is dismissed without acting
//

const ACTION_LABELS = {
  comment:   'leave a comment',
  like:      'like content',
  bookmark:  'bookmark timelines',
  fork:      'fork this timeline',
  follow:    'follow creators',
  react:     'react to timelines',
  carousel:  'export as a carousel',
  create:    'create your own timelines',
  report:    'report content',
};

const AuthPromptModal = ({ action, onSignIn, onSignUp, onClose }) => {
  const label = ACTION_LABELS[action] || 'do that';

  return (
    <Modal open onClose={onClose} title="Join Chronos" width={420}>
      <div style={{ textAlign: 'center', padding: '4px 0 8px' }}>
        <p style={{ color: 'var(--text2)', fontSize: 15, lineHeight: 1.6, marginBottom: 28 }}>
          Create a free account to <strong>{label}</strong>, build your own timelines, and connect with other creators.
        </p>

        <button
          className="btn-primary"
          onClick={onSignUp}
          style={{ width: '100%', marginBottom: 10 }}
        >
          Create Free Account
        </button>

        <button
          className="btn-secondary"
          onClick={onSignIn}
          style={{ width: '100%', marginBottom: 20 }}
        >
          Sign In
        </button>

        <button
          className="btn-ghost btn-sm"
          onClick={onClose}
          style={{ color: 'var(--text3)', fontSize: 13 }}
        >
          Maybe Later
        </button>
      </div>
    </Modal>
  );
};

export default AuthPromptModal;
